import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';

import { toggleModalWithTimer } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import ConfirmEmailCheckInbox from 'apps/auth/components/email/ConfirmEmailCheckInbox';
import Form from 'apps/auth/components/form-multi/Form';
import InputText from 'apps/auth/components/form-multi/InputText';
import ChangePhoneNumberSmsConfirmModal from 'apps/auth/components/profile/ChangePhoneNumberSmsConfirmModal';
import BasePage from 'apps/auth/components/utils/BasePage';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import { CHANGE_EMAIL } from 'apps/auth/constants/formName';
import { AUTH_PROFILE_CHANGE_EMAIL_ACTION, AUTH_PROFILE_FIELDS } from 'apps/auth/constants/UrlConstants';
import { useForm, usePageMessages } from 'apps/auth/hooks/selectors';

const ChangeEmailPage = (props) => {
    const { fields = {}, submitBtnName = '' } = useForm(CHANGE_EMAIL);
    const { headerTitle, headerGrayTitle } = usePageMessages();
    const userCurrentEmail = useRef(fields?.email?.value);
    const popupRef = useRef(null);
    const modalRef = useRef(null);

    const [showConfirm, setShowConfirm] = useState(false);

    const submitHandler = (fields, data) => {
        if (data.extra) {
            if (data.extra.checkInbox && data.messages?.successMessage) {
                props.toggleModalWithTimer(true, data.messages.successMessage, () => {
                    props.toggleModalWithTimer(false, '', false).then(() => setShowConfirm(true));
                });
            } else if (data.extra.smsConfirmation) {
                modalRef.current?.open(<ChangePhoneNumberSmsConfirmModal popupRef={popupRef} modalRef={modalRef} isProfileFlow />);
            }
        }
    };

    if (showConfirm) {
        return <ConfirmEmailCheckInbox />;
    } else {
        return (
            <>
                <CommonPage showChat={false} hasBottomPanel backUrl={AUTH_PROFILE_FIELDS}>
                    <HeaderPanel title={headerTitle} subtitle={headerGrayTitle} />
                    <Form formName={CHANGE_EMAIL} field={fields} action={AUTH_PROFILE_CHANGE_EMAIL_ACTION} onSubmitHandler={submitHandler}>
                        <InputText field={fields.email} formName={CHANGE_EMAIL} isNewInput />
                        <FixedBottomPanel isRightAligned>
                            <Button
                                type="submit"
                                raised={true}
                                caption={submitBtnName}
                                disabled={!fields.email?.value || fields.email?.value === userCurrentEmail.current}
                            />
                        </FixedBottomPanel>
                    </Form>
                </CommonPage>
                <PopupNew ref={popupRef} />
                <ModalNew ref={modalRef} />
            </>
        );
    }
};

export default connect(null, { toggleModalWithTimer })(BasePage(ChangeEmailPage));
